import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from 'services/axiosInstance';
import * as S from './style';
//Components
import LayoutModal from '../../../../LayoutModal';
import Loading from "../../../../Loading";
import AuthPromotion from '../Auth';
//Interface
import { IPromotion } from 'Interfaces/IPromotion';
//hooks
import useLoading from '../../../../../hooks/useLoading';
import { useMultipleModal } from '../../../../../hooks/useMultipleModal';
//utils
import {CurrencyFormat, formatPercentage } from 'utils/CurrencyFormat';

interface IDetails {
    isOpenModalDetails: boolean;
    totalProduct: string;
    setModalClose: () => void;
    dataPayment: (data: {}) => void;
    idProduct: number | null;
    typeUrl: string,
}

type Inputs = {
    discount_id: number,
    discount: string
}

interface IPromo {
    id: number;
    promotion_id: number,
    promotion: IPromotion;
}

type ValueIdType = {
    promotion_id: number | null;
    paymentable_type: string | null;
    paymentable_id: number | null;

    id_payment: number | null;
    name_payment: string | null;
    installment_credit: number | null;
    discount: string | null;
    auth: string | null;
}

export default function Details({
    isOpenModalDetails,
    totalProduct,
    setModalClose,
    dataPayment,
    idProduct,
    typeUrl
}: IDetails) {

    const {
        handleSubmit,
    } = useForm<Inputs>();

    const [data, setData] = useState<IPromo[]>([]);
    const { isLoading, startLoading, stopLoading } = useLoading();
    const { isOpenModal, toggleModalVisibility } = useMultipleModal();
    const {
        isLoading: isLoadingModal,
        startLoading: startLoadingModal,
        stopLoading: stopLoadingModal
    } = useLoading();
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const [selectedPercent, setSelectedPercent] = useState<number>(0);
    const [openIstallment, setOpenInstallment] = useState(false);

    const [idUser, setIdUser] = useState<number | null>(null);

    const [valueId, setValueId] = useState<ValueIdType>({
        promotion_id: null,
        id_payment: null,
        paymentable_id: null,
        paymentable_type: null,
        name_payment: null,
        discount: null,
        auth: null,
        installment_credit: null
    });

    const fetchData = async () => {
        startLoadingModal();
        try {
            // const response = await axiosInstance.get(`frame/${idProduct}`);
            const response = await axiosInstance.get(`${typeUrl}/${idProduct}`);
            const promotionData = response.data.promotion_items;
            setData(promotionData);
        } catch (error) {
            console.error("Erro ao obter dados:", error);
        } finally {
            stopLoadingModal();
        }
    };

    useEffect(() => {
        if (idProduct !== null) {
            fetchData();
        }
    }, [idProduct]);

    const calculateDiscount = () => {
        const valor = Number(totalProduct) || 0;
        const desconto = selectedPercent || 0;
        const result = valor - (valor * desconto / 100);
        return CurrencyFormat(result || 0);
    }

    if (!isOpenModalDetails) {
        return null;
    }

    const selectedPromotions = (
        index: number,
        type: string,
        id: number,
        discount: string,
        form_payment: string,
        auth: string,
        installment: number
    ) => {
        const desconto = parseFloat(discount);
        setSelectedPercent(desconto);
        console.log('id: ', id);

        if (type === 'promotion') {
            setSelectedIndex(index);
            setValueId(prev => ({
                ...prev,
                promotion_id: id,
                auth: auth,
                id_payment: null,
                paymentable_id: null,
                installment_credit: null
            }));
            setOpenInstallment(false);
        } else if (type === 'payment') {
            setValueId(prev => ({
                ...prev,
                id_payment: id,
                paymentable_id: id,
                paymentable_type: 'cash',
                name_payment: form_payment,
                discount: discount,
                installment_credit: null
            }));
            setOpenInstallment(false);
        } else if (type === 'payment-credit') {
            setValueId(prev => ({
                ...prev,
                id_payment: id,
                paymentable_type: 'credit',
                name_payment: form_payment,
                installment_credit: null
            }));
            setOpenInstallment(true);
        } else if (type === 'installment') {
            setValueId(prev => ({
                ...prev,
                paymentable_id: id,
                discount: discount,
                installment_credit: installment
            }));
        }
    }

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        startLoading();
        try {
            const authUser = valueId.auth?.toLowerCase();
            if (authUser === 'administrador' || authUser === 'gerente') {
                toggleModalVisibility('promo');
                return;
            }
            dataPayment({ ...valueId, user_id: idUser });
            closeModal();

        } catch (error: any) {
            alert(error.message); // Exibe a mensagem de erro lançada pelo serviço
        } finally {
            stopLoading();
        }
    };

    const closeModal = () => {
        setValueId({
            promotion_id: null,
            id_payment: null,
            paymentable_id: null,
            paymentable_type: null,
            name_payment: null,
            discount: null,
            auth: null,
            installment_credit: null
        });
        setSelectedIndex(null);
        setOpenInstallment(false);
        setSelectedPercent(0);
        setModalClose();
    }

    // Quando o usuário for autenticado com sucesso
    const handleAuthSuccess = (userId: number) => {
        setIdUser(userId);
        // Agora que temos o ID do usuário, podemos prosseguir com o pagamento
        dataPayment({ ...valueId, user_id: userId });
        toggleModalVisibility('promo'); // Fechar o modal de autenticação
        closeModal();
    };

    return (
        <LayoutModal
            setModalClose={closeModal}
            title='Detalhes do Desconto'
            subTitle='Preencha os dados do desconto do produto.'
            statusLoad={isLoading}
            submiteModal={handleSubmit(onSubmit)}>
            {isLoadingModal || !data ? (
                <Loading />
            ) : (
                <S.Container>

                    <S.Content>
                        <S.listButton>
                            <S.Title>Promoções Disponíveis</S.Title>
                            {
                                data.length > 0 ?
                                    data.map((item, index) => (
                                        <S.Button
                                            onClick={() => selectedPromotions(
                                                index,
                                                'promotion',
                                                item.promotion_id,
                                                '0',
                                                '',
                                                item.promotion.auth,
                                                0
                                            )}
                                            className={valueId.promotion_id === item.promotion_id ? 'active' : ''}
                                        >
                                            <S.Infor>
                                                <S.TitleButton>{item.promotion.title}</S.TitleButton>
                                                <S.Subtitle>Autorização: {item.promotion.auth}</S.Subtitle>
                                            </S.Infor>
                                            <S.highliInfor isActive={false}>5 opções de pagamento</S.highliInfor>
                                        </S.Button>
                                    ))
                                    :
                                    <p>Nenhuma promoção encontrada!</p>
                            }
                        </S.listButton>

                        {
                            selectedIndex !== null && (
                                <S.listButton>
                                    <S.Title>Forma de Pagamento</S.Title>
                                    <S.SeparateDiv>

                                        {data[selectedIndex].promotion.cash_promotions.map((item, index) =>
                                            <S.Button
                                                onClick={() => selectedPromotions(
                                                    index,
                                                    'payment',
                                                    item.id,
                                                    item.discount,
                                                    item.form_payment.form_payment,
                                                    '',
                                                    0
                                                )}
                                                className={valueId.id_payment === item.id ? 'active' : ''}
                                            >
                                                <S.TitleButton>
                                                    {item.form_payment?.form_payment || '-'}
                                                </S.TitleButton>
                                                <S.highliInfor isActive={true}>{formatPercentage(parseFloat(item.discount)) || 0}</S.highliInfor>
                                            </S.Button>
                                        )}

                                        <S.Button
                                            onClick={() => selectedPromotions(
                                                1,
                                                'payment',
                                                -1,
                                                data[selectedIndex].promotion.store_credit_discount,
                                                'Crediário',
                                                '',
                                                0
                                            )}
                                            className={valueId.id_payment === -1 ? 'active' : ''}
                                        >
                                            <S.TitleButton>Crediário</S.TitleButton>
                                            <S.highliInfor isActive={true}>{formatPercentage(parseFloat(data[selectedIndex].promotion.store_credit_discount))}</S.highliInfor>
                                        </S.Button>

                                        <S.Button
                                            onClick={() => selectedPromotions(
                                                1,
                                                'payment-credit',
                                                -2,
                                                '0',
                                                'Crédito',
                                                '',
                                                0
                                            )}
                                            className={valueId.id_payment === -2 ? 'active' : ''}
                                        >
                                            <S.TitleButton>Crédito</S.TitleButton>
                                        </S.Button>
                                    </S.SeparateDiv>
                                </S.listButton>
                            )

                        }

                        {
                            selectedIndex !== null && openIstallment &&
                            <S.listButton>
                                <S.Title>Parcelas</S.Title>
                                <S.SeparateDiv>
                                    {data[selectedIndex].promotion.credit_promotions.map((item, index) =>
                                        <S.Button
                                            onClick={
                                                () => selectedPromotions(index,
                                                    'installment',
                                                    item.id,
                                                    item.discount,
                                                    'Crédito',
                                                    '',
                                                    item.installment
                                                )}
                                            className={valueId.paymentable_id === item.id ? 'active' : ''}
                                        >
                                            <S.TitleButton>
                                                {item.installment || '-'}x
                                            </S.TitleButton>
                                            <S.highliInfor isActive={true}>{formatPercentage(parseFloat(item.discount)) || 0}</S.highliInfor>
                                        </S.Button>
                                    )}
                                </S.SeparateDiv>
                            </S.listButton>
                        }

                    </S.Content>
                    <S.Footer>
                        <S.Title>Resumo</S.Title>

                        <S.ContentInfor>
                            <S.Subtitle>
                                Subtotal
                            </S.Subtitle>
                            <S.Description>
                                {CurrencyFormat(parseFloat(totalProduct) || 0)}
                            </S.Description>
                        </S.ContentInfor>

                        <S.ContentInfor>
                            <S.Subtitle>
                                Desconto
                            </S.Subtitle>
                            <S.Description>
                                {selectedPercent}%
                            </S.Description>
                        </S.ContentInfor>

                        <S.ContentInfor>
                            <S.Subtitle>
                                Total
                            </S.Subtitle>
                            <S.Description>
                                {calculateDiscount()}
                            </S.Description>
                        </S.ContentInfor>
                    </S.Footer>
                </S.Container>
            )}

            <AuthPromotion
                isOpenModalAuth={isOpenModal("promo")}
                setModalClose={() => toggleModalVisibility("promo")}
                onAuthSuccess={handleAuthSuccess}
            />
        </LayoutModal>
    )
}